var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRetry = function SvgRetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 97,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#retry_svg__a)",
    d: "M96.581 2.923H12.666c-1.117 0-2.023.952-2.023 2.126V23.61c0 1.175.906 2.126 2.023 2.126H96.58c1.117 0 2.023-.951 2.023-2.126V5.05c0-1.175-.906-2.127-2.023-2.127"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.643 10.768c0-.293.24-.531.538-.531h2.267c.297 0 .538.238.538.531v6.59c0 .293-.24.53-.538.53h-2.267a.535.535 0 0 1-.538-.53zm6.467 0c0-.293.24-.531.537-.531h2.268c.297 0 .538.238.538.531v6.59c0 .293-.241.53-.538.53h-2.268a.535.535 0 0 1-.537-.53zm7.004-.531a.535.535 0 0 0-.538.531v6.59c0 .293.24.53.538.53h2.267a.535.535 0 0 0 .538-.53v-6.59a.535.535 0 0 0-.538-.531z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.768 12.6H38.413a.267.267 0 0 0-.27.266v2.393c0 .147.121.266.27.266h25.355a.267.267 0 0 0 .27-.266v-2.393a.267.267 0 0 0-.27-.266M78.8 16.867c1.566 0 2.836-1.256 2.836-2.804 0-1.549-1.27-2.804-2.837-2.804-1.566 0-2.836 1.255-2.836 2.804s1.27 2.804 2.837 2.804M87.166 16.867c1.566 0 2.836-1.256 2.836-2.804 0-1.549-1.27-2.804-2.836-2.804-1.567 0-2.837 1.255-2.837 2.804s1.27 2.804 2.837 2.804"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#retry_svg__b)",
    d: "M96.581 26.268H12.666c-1.117 0-2.023.952-2.023 2.126v18.56c0 1.175.906 2.127 2.023 2.127H96.58c1.117 0 2.023-.952 2.023-2.126V28.394c0-1.174-.906-2.126-2.023-2.126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.643 34.113c0-.294.24-.532.538-.532h2.267c.297 0 .538.238.538.532v6.589c0 .294-.24.531-.538.531h-2.267a.535.535 0 0 1-.538-.531zm6.467 0c0-.294.24-.532.537-.532h2.268c.297 0 .538.238.538.532v6.589c0 .294-.241.531-.538.531h-2.268a.535.535 0 0 1-.537-.531zm7.004-.532a.535.535 0 0 0-.538.532v6.589c0 .294.24.531.538.531h2.267a.535.535 0 0 0 .538-.531v-6.59a.535.535 0 0 0-.538-.53z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.768 35.945H38.413a.267.267 0 0 0-.27.266v2.393c0 .147.121.266.27.266h25.355a.267.267 0 0 0 .27-.266v-2.393a.267.267 0 0 0-.27-.266"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M78.8 40.211c1.566 0 2.836-1.255 2.836-2.803 0-1.55-1.27-2.805-2.837-2.805-1.566 0-2.836 1.256-2.836 2.804 0 1.55 1.27 2.804 2.837 2.804M87.166 40.211c1.566 0 2.836-1.255 2.836-2.803 0-1.55-1.27-2.805-2.836-2.805-1.567 0-2.837 1.256-2.837 2.804 0 1.55 1.27 2.804 2.837 2.804"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#retry_svg__c)",
    d: "M96.581 49.613H12.666c-1.117 0-2.023.951-2.023 2.126v18.56c0 1.175.906 2.127 2.023 2.127H96.58c1.117 0 2.023-.952 2.023-2.126V51.739c0-1.175-.906-2.126-2.023-2.126"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.643 57.457c0-.293.24-.531.538-.531h2.267c.297 0 .538.238.538.531v6.59c0 .293-.24.531-.538.531h-2.267a.535.535 0 0 1-.538-.531zm6.467 0c0-.293.24-.531.537-.531h2.268c.297 0 .538.238.538.531v6.59c0 .293-.241.531-.538.531h-2.268a.535.535 0 0 1-.537-.531zm7.004-.531a.535.535 0 0 0-.538.531v6.59c0 .293.24.531.538.531h2.267a.535.535 0 0 0 .538-.531v-6.59a.535.535 0 0 0-.538-.531z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.768 59.29H38.413a.267.267 0 0 0-.27.265v2.394c0 .147.121.266.27.266h25.355a.267.267 0 0 0 .27-.266v-2.394a.267.267 0 0 0-.27-.265"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M78.8 63.556c1.566 0 2.836-1.255 2.836-2.804s-1.27-2.804-2.837-2.804c-1.566 0-2.836 1.255-2.836 2.804s1.27 2.804 2.837 2.804M87.166 63.556c1.566 0 2.836-1.255 2.836-2.804s-1.27-2.804-2.836-2.804c-1.567 0-2.837 1.255-2.837 2.804s1.27 2.804 2.837 2.804"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#retry_svg__d)",
    d: "M96.874 42.94c1.81-2.707 5.829-2.707 7.638 0l25.835 38.648c2.011 3.008-.172 7.02-3.819 7.02h-51.67c-3.647 0-5.83-4.012-3.819-7.02z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M92.717 40.162c3.79-5.67 12.163-5.67 15.952 0l25.835 38.647c4.291 6.419-.439 14.798-7.976 14.798h-51.67c-7.536 0-12.266-8.379-7.975-14.798zm11.795 2.778c-1.809-2.707-5.828-2.707-7.638 0L71.039 81.588c-2.01 3.008.172 7.02 3.82 7.02h51.669c3.647 0 5.83-4.012 3.819-7.02z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M97.628 72.152h5.242l.699-14.96h-6.64zm2.621 1.554c-1.957 0-3.425 1.451-3.425 3.386s1.468 3.386 3.425 3.386 3.425-1.451 3.425-3.386-1.468-3.386-3.425-3.386"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "retry_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-74.27296 20.66055 -9.92134 -35.6664 91.912 4.408)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "retry_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-74.27296 20.66055 -9.92134 -35.6664 91.912 27.753)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1AABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFCCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "retry_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-74.27296 20.66055 -9.92134 -35.6664 91.912 51.098)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6BDCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8D3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "retry_svg__d",
    x1: 100.693,
    x2: 100.693,
    y1: 37.227,
    y2: 105.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7878"
  })))));
};
export default SvgRetry;